





































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import http from "@/axios/http-common";
import { ProcedureItem } from "@/types/diag_procedure";

@Component
export default class ProcedureItemRow extends Vue {
  @Prop({
    default: null
  })
  item: ProcedureItem;
  @Ref() itemName: HTMLInputElement;

  icd = null;
  name = null;
  time = null;
  selected = null;

  searchString = null;
  searchItemLoading = false;

  prosList = [];

  _timerId;

  mounted() {
    this.changedItem(this.item);
  }

  focus() {
    this.itemName.focus();
  }

  itemChangeName(val) {
    const isString = typeof val == "string";

    if (isString) {
      this.icd = null;
      this.name = this.selected;
      this.time = null;
    } else {
      this.icd = this.selected.kode;
      this.name = this.selected.tindakan;
      this.time = null;
    }

    this.searchString = "";

    this.$emit("selectedItem", {
      icd: this.icd,
      name: this.name,
      time: this.time
    });
  }

  itemChanged() {
    this.$emit("selectedItem", {
      icd: this.icd,
      name: this.name,
      time: this.time
    });
  }

  add() {
    this.$emit("add");
  }

  remove() {
    this.$emit("remove");
  }

  searchProcedure(termSearch) {
    this.searchItemLoading = true;
    http
      .getDataParam("/referensi/prosedur-icd/search", {
        params: { term: termSearch }
      })
      .then(res => {
        this.prosList = res.data;
      })
      .finally(() => {
        this.searchItemLoading = false;
      });
  }

  @Watch("searchString")
  searched() {
    this.prosList = [];

    if (this.searchString === null) {
      this.icd = null;
    }

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      if (this.name === this.searchString) return;

      this.searchProcedure(this.searchString);
    }, 500);
  }

  @Watch("item", { deep: true })
  changedItem(val: ProcedureItem) {
    this.icd = val.icd;
    this.name = val.name;
    this.time = val.time;
    this.selected = val.name;
  }
}
